import {
  API_PATHS,
  SEGMENT_POLL_INTERVAL_MS,
  SEGMENT_POLL_MAX_ATTEMPTS,
} from '../config';
import { request } from './client';
import { unwrapApiData, normalizeSegmentList } from '../utils/apiResponse';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function pollSegmentTask(taskId, options = {}) {
  const {
    intervalMs = SEGMENT_POLL_INTERVAL_MS,
    maxAttempts = SEGMENT_POLL_MAX_ATTEMPTS,
    onProgress,
  } = options;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const payload = await request(API_PATHS.segmentTask(taskId));
    const data = unwrapApiData(payload);
    if (onProgress) {
      onProgress({
        status: data.status,
        progressPercent: data.progressPercent,
        progressMessage: data.progressMessage,
      });
    }
    if (data.status === 'SUCCESS') {
      return {
        taskId: data.taskId,
        projectId: data.projectId,
        status: data.status,
        segments: normalizeSegmentList(data.segments || []),
      };
    }
    if (data.status === 'FAILED' || data.status === 'CANCELLED') {
      throw new Error(data.errorMessage || data.progressMessage || '切片任务失败');
    }
    await sleep(intervalMs);
  }
  throw new Error('切片任务超时，请稍后在任务列表中查看');
}
